// extracted by mini-css-extract-plugin
export default {"SectionSubtitle":"SectionTitle_SectionSubtitle__P-2ga","SectionTitle":"SectionTitle_SectionTitle__WD8ZH"};